import { PUBLICATIONS_API_PATH, PUBLISHING_API_PATH } from "api/api-constants";
import { reportApiError, serverApi } from "api/api-server-actions";
import { PublicationType, SectionType } from "components/server-types";
import { slices, store } from "store/index";

export async function serverCreateLinkedSections(
  sectionId: string,
  count: number,
  title: string,
): Promise<void> {
  try {
    const response = await serverApi.post(`${PUBLISHING_API_PATH}/linked_sections/`, {
      section_id: sectionId,
      count,
      title,
    });
    const sections = response.data as SectionType[];
    store.dispatch(slices.sections.actions.updateMany(sections));
  } catch (error) {
    reportApiError("serverCreateLinkedSections", error);
    throw error;
  }
}

export async function serverPublishDraftPublication(publicationId: string): Promise<void> {
  try {
    const response = await serverApi.post(`${PUBLICATIONS_API_PATH}/${publicationId}/publish/`, {
      publication_id: publicationId,
    });
    const publication = response.data as PublicationType;
    store.dispatch(slices.publications.actions.updateOne(publication));
  } catch (error) {
    reportApiError("serverPublishDraftPublication", error);
    throw error;
  }
}

/** Ensures a draft publication exists for a template section (POST …/publications/ensure_draft/). */
export async function serverEnsureDraftPublication(
  sectionId: string,
): Promise<PublicationType | null> {
  try {
    const response = await serverApi.post(`${PUBLICATIONS_API_PATH}/ensure_draft/`, {
      section_id: sectionId,
    });
    if (response.status === 204) {
      return null;
    }
    const publication = response.data as PublicationType;
    store.dispatch(slices.publications.actions.updateOne(publication));
    return publication;
  } catch (error) {
    reportApiError("serverEnsureDraftPublication", error);
    throw error;
  }
}

export async function serverFetchLatestPublications(sectionId?: string): Promise<void> {
  try {
    const response = await serverApi.get(`${PUBLICATIONS_API_PATH}/latest/`, {
      params: sectionId ? { section_id: sectionId } : undefined,
    });
    const publications = response.data as PublicationType[];
    store.dispatch(slices.publications.actions.updateMany(publications));
  } catch (error) {
    reportApiError("serverFetchLatestPublications", error);
    throw error;
  }
}
